import { useState } from 'react';
import Script from 'next/script';
import useGoogleOneTap from '@sy/app-client/src/ssrAdapter/components/useGoogleOneTap';

const WithGoogleOneTap = () => {
	const [hasGoogleGsiScriptLoaded, setHasGoogleGsiScriptLoaded] =
		useState(false);

	useGoogleOneTap({
		hasGoogleGsiScriptLoaded,
	});

	return (
		<Script
			id="googleGsi"
			strategy="afterInteractive"
			src="https://accounts.google.com/gsi/client"
			onLoad={() => setHasGoogleGsiScriptLoaded(true)}
		/>
	);
};

export default WithGoogleOneTap;
